import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const ReportReprintSlice = createSlice({
  name: "ReportReprintSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    ReportReprint: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successReportReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureReportReprint: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearReportReprint: (state) => {
      state.data = {};
    },
  },
});

export const {
  ReportReprint,
  failureReportReprint,
  successReportReprint,
  clearReportReprint,
} = ReportReprintSlice.actions;

export default ReportReprintSlice.reducer;
